var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart_nano"},[(_vm.amount > 0)?[_c('a',{attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.str))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }